import React, { useState, useEffect, useMemo } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CustomPagination from "../../../common/custompagination";
import Sorting from "../../../common/sorting";
import Breadcrums from "../../../common/breadcrumbs";
import Chart from "react-apexcharts";
import {
    capitalizeFirstLetter,
    formateDateWithMonth,
    removeSpecialCharacter,
    TrimText,
    writeMyExcel,
} from "../../../../../utils/commonfunction";
import { Placeholder, Tooltip, Whisper } from "rsuite";
import { AssociateReportList, ProductList } from "../../../services/reports.sevices";
import ReportCharts from "../reportCharts";
const ProductReport = () => {
    const { t } = useTranslation();
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const [list, setList] = useState([]);
    const [statsupdate, setStatusUpdate] = useState("false");
    const [datalength, setDataLength] = useState("");
    const [itemperpage] = useState(10);
    const [sorting, setSorting] = useState({});
    const [defaultSorting, setDefaultSorting] = useState(true);
    const [page, setPage] = useState(1);
    const [loader, setLoader] = useState(true);
    const [search, setSearch] = useState({});
    const [globalsearch, setGlobalSearch] = useState("");
    const breadcrumbs = [
        { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
        { title: "Associate Reports", url: "" },
    ];
    const [resetdate, setResetDate] = useState(false);
    const [statusUpdated, setStatusUpdated] = useState(false);
    const [downloadReport, setDownloadReport] = useState(false);
    const [filter, setFilter] = useState("30d");

    useEffect(() => {
        const getData = setTimeout(() => {
            if (search) {
                setLoader(true);
                const formData = new FormData();
                formData.append("page", params.pgno);
                formData.append("per_page", itemperpage);
                formData.append("sort", JSON.stringify(sorting));
                formData.append("search", JSON.stringify(search));
                formData.append("global_search", globalsearch);
                ProductList(formData)
                    .then((data) => {
                        setDataLength(data.data.total_records);
                        setList(
                            (data && data.data && data.data.list ? data.data.list : []).filter(
                                (item) => !(Array.isArray(item.role) && item.role[0] === "babe_user")
                            )
                        );
                        setPage(data && data.data && data.data.page ? data.data.page : 1);
                        setLoader(false);
                    })
                    .catch((error) => {
                        setLoader(false);
                        console.log("error ====> ", error);
                    });
            }
        }, 300);
        return () => clearTimeout(getData)
    }, [
        location,
        statsupdate,
        sorting,
        search,
        globalsearch,
        itemperpage,
        params.pgno,
        statusUpdated
    ]);

    const handleExportToPDF = () => {
        setDownloadReport(true);
        const formData = new FormData();
        formData.append("page", 1);
        formData.append("per_page", datalength);
        formData.append("sort", JSON.stringify(sorting));
        formData.append("search", JSON.stringify(search));
        formData.append("global_search", globalsearch);
        formData.append("filter", filter);
        
        ProductList(formData)
            .then((data) => {
                setDownloadReport(false);
                const reportData = data?.data?.list || [];
                
                // Create PDF content
                let pdfContent = `
                    <!DOCTYPE html>
                    <html>
                    <head>
                        <style>
                            body { font-family: Arial, sans-serif; padding: 20px; }
                            h1 { text-align: center; color: #333; margin-bottom: 30px; }
                            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
                            th { background-color: #4CAF50; color: white; padding: 12px; text-align: left; border: 1px solid #ddd; }
                            td { padding: 10px; border: 1px solid #ddd; }
                            tr:nth-child(even) { background-color: #f2f2f2; }
                            .total { font-weight: bold; margin-top: 20px; }
                        </style>
                    </head>
                    <body>
                        <h1>Products Report</h1>
                        <table>
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Product Name</th>
                                    <th>Price</th>
                                    <th>Seller Name</th>
                                    <th>Unique Customers</th>
                                    <th>Total Quantity</th>
                                    <th>Total Revenue</th>
                                    <th>Created Date</th>
                                </tr>
                            </thead>
                            <tbody>
                `;
                
                reportData.forEach((row, index) => {
                    pdfContent += `
                        <tr>
                            <td>${index + 1}</td>
                            <td>${row?.product_name || 'N/A'}</td>
                            <td>${row?.price || '0'}</td>
                            <td>${row?.seller?.name || 'N/A'}</td>
                            <td>${row?.unique_customers || '0'}</td>
                            <td>${row?.total_quantity_sold || '0'}</td>
                            <td>${row?.total_revenue || '0'}</td>
                            <td>${row?.createdAt ? formateDateWithMonth(row.createdAt) : 'N/A'}</td>
                        </tr>
                    `;
                });
                
                pdfContent += `
                            </tbody>
                        </table>
                        <p class="total">Total Records: ${reportData.length}</p>
                    </body>
                    </html>
                `;
                
                // Create a new window and print
                const printWindow = window.open('', '_blank');
                printWindow.document.write(pdfContent);
                printWindow.document.close();
                printWindow.focus();
                
                // Wait for content to load then print
                setTimeout(() => {
                    printWindow.print();
                }, 500);
            })
            .catch((error) => {
                setDownloadReport(false);
                console.log("error ====> ", error);
            });
    };


    // sorting function start

    const handleSort = (e, column) => {
        setDefaultSorting(false);
        let sort = { order: 0, column: column };
        if (e.target.classList.contains("assc")) {
            sort.order = -1;
        } else {
            sort.order = 1;
        }
        setSorting(sort);
    };
    // sorting end

    // search or filter function
    const prepareSearch = (key, value) => {
        let sr = { ...search };
        if (String(value).length > 0) {
            sr[key] = value;
        } else {
            delete sr[key];
        }
        setSearch(sr);
    };


    const resetFilter = (e) => {
        e.preventDefault();
        setGlobalSearch("");
        prepareSearch();
        setSearch({});
        setResetDate(!resetdate);
        // $("#defaultstatus")[0].selectedIndex = 0;
    };
    return (
        <>
            <Breadcrums data={breadcrumbs} />
            {/* Below section has code of charts */}
           

            {/* Below section has code of table */}
            <div className="animation_fade">
                <div className="card custom-card">
                    <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <h6 className="main-content-label">
                                User Reports
                            </h6>
                            <div className="d-flex align-items-center">
                                <div className="form-group mb-0 me-3">
                                    <div className="form-group mb-0 rangepicker_container filter_design">
                                        <i className="fa fa-search calender_icon"></i>
                                        <input
                                            type="search"
                                            className="form-control"
                                            value={globalsearch}
                                            placeholder={t("input_placeholder_search")}
                                            onChange={(e) => {
                                                setGlobalSearch(e.target.value);
                                            }}
                                        />
                                    </div>
                                </div>
                                {/* <div className="me-3">
                                    <StatusFilter data={USER} prepareSearch={prepareSearch} />
                                </div> */}
                                <button
                                    type="button"
                                    onClick={() => { handleExportToPDF() }}
                                    className="btn ripple btn-main-primary signbtn"
                                    disabled={downloadReport}
                                >
                                    {downloadReport ? t("Exporting...") : t("btn_export_report")}
                                </button>
                                <button
                                    type="reset"
                                    value="Reset"
                                    onClick={resetFilter}
                                    className="btn ripple btn-main-primary signbtn ms-2"
                                >
                                    {t("btn_reset_filter")}
                                </button>
                            </div>
                        </div>
                        {loader ?
                            <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={30} rowSpacing={5} active={true} rows={7} />
                            :
                            <>
                                <div className="table-responsive min-h-400">
                                    <table className="table table-bordered card-table border-top text-nowrap w-100">
                                        <thead>
                                            <tr>
                                                <th className="position-relative select_head">
                                                    <span>{t("list_heading_sno")}</span>
                                                </th>
                                                <th>
                                                    <div className="sorting_column">
                                                        <span>{t("label_product_name")}</span>
                                                        <Sorting
                                                            sort={sorting}
                                                            handleSort={handleSort}
                                                            column="product_name"
                                                        />
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="sorting_column">
                                                        <span>{t("Price")}</span>
                                                        <Sorting
                                                            sort={sorting}
                                                            handleSort={handleSort}
                                                            column="price"
                                                        />
                                                    </div>
                                                </th>
                                                <th>{t("label_seller_name")}</th>
                                                <th>
                                                    <div className="sorting_column">
                                                        <span>{t("Unique Customers")}</span>
                                                        <Sorting
                                                            sort={sorting}
                                                            handleSort={handleSort}
                                                            column="unique_customers"
                                                        />
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="sorting_column">
                                                        <span>{t("label_total_quantity")}</span>
                                                        <Sorting
                                                            sort={sorting}
                                                            handleSort={handleSort}
                                                            column="total_quantity_sold"
                                                        />
                                                    </div>
                                                </th>
                                                <th className="">{t("label_total_revenue")}</th>
                                                <th className="created_head">
                                                    <div className="sorting_column">
                                                        <span>{t("list_heading_created_date")}</span>
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <>
                                                {list.length ? (
                                                    list.map((row, i) => {
                                                        return (
                                                            <tr
                                                                key={i}
                                                            >
                                                                <td>
                                                                    {row ? ((page - 1) * itemperpage) + i + 1 : null}
                                                                </td>

                                                                <td>{row?.product_name ? <div className="d-flex">{row?.product_name ? TrimText(capitalizeFirstLetter(row?.product_name), 20) : "N/A"}</div> : <div className="d-flex">N/A</div>}</td>

                                                                <td>{row?.price ? row.price : "0"}</td>

                                                                <td>{row?.seller?.name ? TrimText(capitalizeFirstLetter(row?.seller?.name), 20) : "N/A"} </td>
                                                                <td>{row?.unique_customers ? row.unique_customers : "0"}</td>

                                                                <td>{row?.total_quantity_sold ? row.total_quantity_sold : "N/A"}</td>
                                                                <td>{row?.total_revenue ? row.total_revenue : "0"}</td>
                                                                <td>
                                                                    {row?.createdAt
                                                                        ? formateDateWithMonth(row.createdAt)
                                                                        : "N/A"}
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan={10} className="text-center">
                                                            {t("msg_no_records")}
                                                        </td>
                                                    </tr>
                                                )}
                                            </>
                                        </tbody>
                                    </table>
                                </div>
                                <div
                                    className=""
                                    id="example1_info"
                                    role="status"
                                    aria-live="polite"
                                >
                                    <b>
                                        {t("msg_total_records")} : {datalength ? datalength : "0"}
                                    </b>
                                </div>
                                {datalength && datalength > 0 ? (
                                    <CustomPagination
                                        datalength={datalength}
                                        itemperpage={itemperpage}
                                        currentPage={page}
                                        setPage={setPage}
                                        pageRoute={[
                                            {
                                                name: "Reataurant",
                                                path: "/admin/reports/list",
                                            },
                                        ]}
                                    />
                                ) : (
                                    ""
                                )}
                            </>
                        }
                    </div>
                </div>
            </div>

        </>
    );
};

export default ProductReport;
